// Google Analytics 4 utility
// Initializes gtag and exports a track() helper used throughout the app

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function initGA() {
  if (!GA_ID) return;
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
}

// Track page views — call on every route change
export function trackPage(path) {
  if (!window.gtag || !GA_ID) return;
  window.gtag('config', GA_ID, { page_path: path });
}

// Track custom events
// e.g. track('verdict_submitted', { verdict: 'valid' })
export function track(eventName, params = {}) {
  if (!window.gtag || !GA_ID) return;
  window.gtag('event', eventName, params);
}
